<script>
import { crudMethods } from '@state/helpers'

export default {
  name: 'CompPanjarRecon',
  props: {
    idProyek: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      title: 'Rekonsiliasi Panjar',
      proyekId: this.idProyek,
      selectedFile: null,
      isDragging: false,
      loadingPreview: false,
      loadingStore: false,
      modalPreviewRecon: false,
      modalError: false,
      messageError: '',
      currentProyekInfo: {
        kode_proyek: '',
        nama_proyek: '',
      },
      reconItems: [],
    }
  },
  computed: {
    isFileSelected() {
      return this.selectedFile !== null
    },
    hasOverAmount() {
      return this.reconItems.some(
        (item) => item.ikhtisar.status_ikhtisar === 'OVER_AMOUNT'
      )
    },
  },
  watch: {
    idProyek(newVal) {
      this.proyekId = newVal
      this.removeFile()
      if (newVal) {
        this.getProyekDetail()
      }
    },
  },
  mounted() {
    if (this.proyekId) {
      this.getProyekDetail()
    }
  },
  methods: {
    ...crudMethods,
    getProyekDetail() {
      this.listData({
        url: '/web/transaksi/proyek/' + this.proyekId,
      })
        .then((response) => {
          var { data } = response.data
          this.currentProyekInfo.kode_proyek = data.kode_proyek
          this.currentProyekInfo.nama_proyek = data.nama_proyek
        })
        .catch(() => {
          this.currentProyekInfo.kode_proyek = 'UNKNOWN'
          this.currentProyekInfo.nama_proyek = 'Tidak Diketahui'
        })
    },
    handleDrop(e) {
      this.isDragging = false
      var files = e.dataTransfer.files
      if (files.length) {
        this.selectedFile = files[0]
      }
    },
    onFileChange(e) {
      var files = e.target.files
      if (files.length) {
        this.selectedFile = files[0]
      }
    },
    removeFile() {
      this.selectedFile = null
      this.reconItems = []
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    uploadAndPreview() {
      if (!this.selectedFile) return

      this.loadingPreview = true
      var formData = new FormData()
      formData.append('file_excel', this.selectedFile)

      this.insertData({
        url: '/web/transaksi/proyek/' + this.proyekId + '/panjar-recon/preview',
        body: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          this.reconItems = response.data
          this.loadingPreview = false
          this.modalPreviewRecon = true
          // this.toast(
          //   'b-toaster-bottom-right',
          //   true,
          //   'Preview Berhasil Dimuat',
          //   'success'
          // )
        })
        .catch((err) => {
          this.loadingPreview = false
          this.selectedFile = null
          try {
            var message = JSON.parse(err.response.request.response)
            this.messageError = message.message
          } catch (e) {
            this.messageError =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Gagal memproses file Excel.'
          }
          this.modalError = true
        })
    },
    executeStoreReconciliation() {
      this.loadingStore = true
      var formData = new FormData()
      formData.append('file_excel', this.selectedFile)

      this.insertData({
        url: '/web/transaksi/proyek/' + this.proyekId + '/panjar-recon/store',
        body: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          this.loadingStore = false
          this.modalPreviewRecon = false
          this.removeFile()
          this.toast(
            'b-toaster-bottom-right',
            true,
            response.data.message || 'Rekonsiliasi berhasil disimpan.',
            'success'
          )
          this.$emit('success-store')
        })
        .catch((err) => {
          this.loadingStore = false
          try {
            var message = JSON.parse(err.response.request.response)
            this.messageError = message.message
          } catch (e) {
            this.messageError =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Gagal menyimpan rekonsiliasi ke Database.'
          }
          this.modalError = true
        })
    },
    formatRupiah(value) {
      // 1. Amankan jika nilainya kosong/null/undefined
      if (value === undefined || value === null || value === '') {
        return '0'
      }

      // 2. Paksa konversi tipe data apapun (termasuk String dari API) menjadi Number murni
      var numericValue = Number(value)

      // 3. Jika hasil konversinya gagal / menghasilkan NaN (Not a Number), balikkan ke '0'
      if (isNaN(numericValue)) {
        return '0'
      }

      // 4. Sekarang toFixed(0) dijamin 100% aman karena numericValue sudah pasti bertipe Number
      return numericValue
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getBadgeClass(status) {
      if (status === 'DONE') return 'badge badge-success px-3 py-1 font-size-12'
      if (status === 'PARTIAL')
        return 'badge badge-warning px-3 py-1 font-size-12'
      return 'badge badge-danger px-3 py-1 font-size-12'
    },
    getAlertClass(status) {
      if (status === 'DONE')
        return 'alert-soft-success border-success text-success'
      if (status === 'PARTIAL')
        return 'alert-soft-warning border-warning text-warning-dark'
      return 'alert-soft-danger border-danger text-danger'
    },
    toast(toaster, append, body, variant) {
      this.$bvToast.toast(body + '', {
        title: 'Sistem Rekonsiliasi',
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: variant,
      })
    },
    // Fungsi pembantu baru untuk menghindari penulisan logika rumit / pemanggilan ref di dalam HTML inline event click
    triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    closePreviewModal() {
      this.modalPreviewRecon = false
    },
    closeErrorModal() {
      this.modalError = false
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <h5 class="font-weight-bold text-dark mb-1">Form {{ title }}</h5>
        <p class="text-muted font-size-13">
          Proyek Aktif:
          <span class="badge badge-soft-primary font-size-12 font-weight-bold">
            {{ currentProyekInfo.kode_proyek }} -
            {{ currentProyekInfo.nama_proyek }}
          </span>
        </p>
      </div>
    </div>

    <div class="row justify-content-center my-3">
      <div class="col-sm-12">
        <div
          class="dropzone-area text-center p-5 rounded border"
          :class="{ 'dropzone-active': isDragging }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="handleDrop"
          @click="triggerFileInput"
        >
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx, .xls, .csv"
            class="d-none"
            @change="onFileChange"
          />

          <div v-if="!selectedFile">
            <i class="uil uil-cloud-upload display-4 text-primary mb-2"></i>
            <h5 class="font-size-15 font-weight-bold"
              >Klik atau Tarik File Excel Rekon ke Sini</h5
            >
            <p class="text-muted font-size-12 mb-0"
              >Mendukung format file .xlsx, .xls atau .csv (Max. 10MB)</p
            >
          </div>
          <div v-else @click.stop="triggerFileInput">
            <i class="uil uil-file-check-alt display-4 text-success mb-2"></i>
            <h5 class="text-truncate px-3 font-size-14 font-weight-bold">{{
              selectedFile.name
            }}</h5>
            <p class="text-muted font-size-13 mb-3"
              >Ukuran: {{ (selectedFile.size / 1024).toFixed(1) }} KB</p
            >
            <button
              class="btn btn-danger btn-xs rounded-pill px-3"
              @click.stop="removeFile"
            >
              <i class="uil uil-trash-alt mr-1"></i> Ganti File
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-center mt-3">
      <div class="col-sm-12">
        <button
          class="btn btn-primary btn-block rounded-0 py-2"
          :disabled="!isFileSelected || loadingPreview"
          @click="uploadAndPreview"
        >
          <span v-if="loadingPreview">
            <b-spinner small class="mr-1"></b-spinner> Membaca Lembar Kerja...
          </span>
          <span v-else>
            <i class="uil uil-eye mr-1"></i> PROSES & PREVIEW DATA REKON
          </span>
        </button>
      </div>
    </div>

    <b-modal
      v-model="modalPreviewRecon"
      size="xl"
      title-class="text-center font-weight-bold"
      centered
      no-close-on-backdrop
      modal-class="modal-print"
      title="Preview Hasil Rekonsiliasi Panjar"
    >
      <div class="text-center mb-3">
        <h4 class="font-weight-bold mb-1"
          >Ikhtisar Data Hasil Komparasi Rekon</h4
        >
        <small class="text-muted text-uppercase">
          Proyek: {{ currentProyekInfo.kode_proyek }} -
          {{ currentProyekInfo.nama_proyek }}
        </small>
      </div>

      <div
        v-for="(item, index) in reconItems"
        :key="index"
        class="card border shadow-none mb-4"
      >
        <div
          class="card-header bg-light d-flex justify-content-between align-items-center py-2"
        >
          <h6 class="font-weight-bold mb-0 text-primary">
            <i class="uil uil-layers mr-1"></i> No. Batch Panjar: #{{
              item.batch
            }}
          </h6>
          <span :class="getBadgeClass(item.ikhtisar.status_ikhtisar)">
            {{ item.ikhtisar.status_ikhtisar }}
          </span>
        </div>

        <div class="card-body p-3">
          <div
            class="row mb-3 bg-light p-2 rounded mx-0 text-center text-sm-left"
          >
            <div class="col-md-3 mb-2 mb-md-0">
              <small class="text-muted d-block">Grand Total DB:</small>
              <span class="font-weight-bold text-dark"
                >Rp {{ formatRupiah(item.ikhtisar.grand_total_db) }}</span
              >
            </div>
            <div class="col-md-3 mb-2 mb-md-0">
              <small class="text-muted d-block">Sudah Direkon Dulu:</small>
              <span class="font-weight-bold text-info"
                >Rp {{ formatRupiah(item.ikhtisar.already_reconciled) }}</span
              >
            </div>
            <div class="col-md-3 mb-2 mb-md-0">
              <small class="text-muted d-block">Sisa Plafon di DB:</small>
              <span class="font-weight-bold text-warning"
                >Rp {{ formatRupiah(item.ikhtisar.sisa_panjar_db) }}</span
              >
            </div>
            <div class="col-md-3 border-left">
              <small class="text-muted d-block">Total Excel Saat Ini:</small>
              <span class="font-weight-bold text-primary"
                >Rp
                {{ formatRupiah(item.ikhtisar.total_nilai_panjar_excel) }}</span
              >
            </div>
          </div>

          <div
            :class="getAlertClass(item.ikhtisar.status_ikhtisar)"
            class="alert py-2 px-3 mb-3 font-size-13"
          >
            <i class="uil uil-info-circle mr-1"></i>
            {{ item.ikhtisar.keterangan_rekon }}
          </div>

          <p class="font-weight-bold mb-2 font-size-13 text-secondary">
            Rincian Baris Berkas Excel ({{ item.ikhtisar.jumlah_baris_excel }}
            Baris)
          </p>
          <div class="table-responsive">
            <table
              class="table table-sm table-bordered table-hover mb-0 font-size-13"
            >
              <thead class="thead-light text-center">
                <tr>
                  <th width="5%">No</th>
                  <th width="15%">Tanggal Nota</th>
                  <th>Uraian Rekon</th>
                  <th width="20%" class="text-right">Nominal (Rp)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detail, dIndex) in item.ikhtisar.excel_details"
                  :key="dIndex"
                >
                  <td class="text-center">{{ dIndex + 1 }}</td>
                  <td class="text-center text-muted">{{
                    detail.tgl || '-'
                  }}</td>
                  <td>{{ detail.uraian }}</td>
                  <td class="text-right font-weight-medium">
                    {{ detail.nilai_panjar < 0 ? '-' : '' }}Rp
                    {{ formatRupiah(Math.abs(detail.nilai_panjar)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          @click="closePreviewModal"
          :disabled="loadingStore"
        >
          Kembali/Batal
        </b-button>
        <b-button
          variant="success"
          @click="executeStoreReconciliation"
          :disabled="loadingStore || reconItems.length === 0"
        >
          <span v-if="loadingStore">
            <b-spinner small class="mr-1"></b-spinner> Menyimpan...
          </span>
          <span v-else>
            <i class="uil uil-check-circle mr-1"></i> SIMPAN REKON KE DB
          </span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="modalError"
      size="sm"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="text-center p-2">
        <i class="uil uil-times-circle text-danger display-4 mb-2 d-block"></i>
        <h3 class="font-size-14 font-weight-bold mb-2"
          >Gagal Memproses Rekon</h3
        >
        <p class="text-muted font-size-13 mb-3">{{ messageError }}</p>
        <button
          class="btn btn-sm btn-primary btn-block"
          @click="closeErrorModal"
          >Tutup Pesan</button
        >
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.dropzone-area {
  border: 2px dashed #727cf5 !important;
  background-color: #faffff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.dropzone-area:hover,
.dropzone-active {
  background-color: #f1f3fa;
  border-color: #0acf97 !important;
}
.text-warning-dark {
  color: #a17200;
}
.alert-soft-success {
  background-color: rgba(10, 207, 151, 0.1);
}
.alert-soft-warning {
  background-color: rgba(249, 200, 80, 0.15);
}
.alert-soft-danger {
  background-color: rgba(250, 92, 124, 0.1);
}
</style>
